import styled from 'styled-components';

export default function AdminLiveVisibilityBadge({ secretYn }: { secretYn?: string | null }) {
  const visibility = secretYn === 'y' ? 'secret' : secretYn === 'n' ? 'public' : 'unknown';
  const label = visibility === 'secret' ? '시크릿' : visibility === 'public' ? '공개' : '구분 미확인';

  return <Badge $visibility={visibility} aria-label={`방송 공개 구분: ${label}`}>{label}</Badge>;
}

const Badge = styled.span<{ $visibility: 'secret' | 'public' | 'unknown' }>`
  box-sizing: border-box;
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  min-height: var(--control-sm);
  padding-inline: var(--space-2);
  border: 1px solid var(--color-border-default);
  border-radius: var(--radius-sm);
  background: ${({ $visibility }) => $visibility === 'secret' ? 'var(--color-info-subtle)' : 'var(--color-bg-muted)'};
  color: ${({ $visibility }) => $visibility === 'secret' ? 'var(--color-info)' : $visibility === 'public' ? 'var(--color-text-primary)' : 'var(--color-text-secondary)'};
  font-family: var(--font-family-base);
  font-size: var(--text-caption);
  font-weight: var(--font-weight-medium);
  line-height: var(--leading-caption);
  white-space: nowrap;
`;
